import { useState, useRef, useEffect } from 'react';
import './station.css';

import arrowimg from "./img/arrow.svg";
import lockimg from "./img/lock.svg";

import hinticon from "./img/lightbulb.svg";

import ContentVideo from './contenttypes/ContentVideo';
import ContentQuiz from './contenttypes/ContentQuiz';
import ContentImage from './contenttypes/ContentImage';
import ContentCamera from './contenttypes/ContentCamera';
import ContentAudio from './contenttypes/ContentAudio-leiste';
import ContentExternal from './contenttypes/ContentExternal';
import ContentGame from './contenttypes/ContentGame';
import ContentScratch from './contenttypes/ContentScratch.js';
import ContentCode from './contenttypes/ContentCode.js';
import ContentColorFilter from './contenttypes/ContentColorFilter.js';
import ContentInspector from './contenttypes/ContentInspector.js';
import ContentMagnifier from './contenttypes/ContentMagnifier.js';

import StationSuccess from './StationSuccess';

import { useParams, useNavigate } from 'react-router-dom';

import { handleApiResponse } from './functions/handleApiResponse.js';

import { translate } from './functions/translationHelper';
import { useLoadingRecovery } from './functions/useLoadingRecovery';
import {
  applyLocalProgressToStationData,
  getContentsSnapshotKey,
  getOfflineAwareJson,
} from './functions/offlineStore';

import ModalHints from './components/ModalHints.js';


function Station() {

  let { regionid, stationid } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { needsManualReload, reloadNow, triggerRecovery } = useLoadingRecovery({
    active: loading,
  });

  const [index, setIndex] = useState(0);

  let mockdata = {
    title: "Der Auerhahn",
    image: "...",
    language: "de",
    contents: []
  }



  const [showButtons, setShowButtons] = useState(true);


  const [lockedContents, setLockedContents] = useState([]);

  const [entryTime, setEntryTime] = useState(Date.now());

  const [hintsOpen, setHintsOpen] = useState(false);

  const newcontents = JSON.parse(data?.newcontents || "[]");

  const currentContent = newcontents?.[index];
  const stationNextButtonText =
    currentContent?.buttontext || translate("next", data.language);
  const currentHints = currentContent?.hints; // array expected
  const hasHints = Array.isArray(currentHints) && currentHints.length > 0;

  const handleContentCompletion = (completedIndex) => {
    setLockedContents((prevLockedContents) => {
      if (!prevLockedContents[completedIndex]) return prevLockedContents;

      const updatedLockedContents = [...prevLockedContents];
      updatedLockedContents[completedIndex] = false;
      return updatedLockedContents;
    });
    //setTimeout(() => indexnext(), 800);
  };

  function indexprev() {
    if (index > 0) {
      setIndex(prev => prev - 1);
    }
  }

  function indexnext() {
    if (index < newcontents.length && !lockedContents[index]) {
      setIndex(prev => prev + 1);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    console.log("Locked contents:" + lockedContents);
  }, [lockedContents]);



  const fetchData = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}getContents.php?region=${regionid}&stationid=${stationid}`;
      const data = await getOfflineAwareJson({
        key: getContentsSnapshotKey(regionid, stationid, localStorage.getItem("language") || "en"),
        url,
        options: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('uuid')}`,
        }
        },
      });
      console.log(data);
      if (data.code !== undefined) {
        handleApiResponse(data.code, regionid, navigate);
      } else {
        const dataWithLocalProgress = await applyLocalProgressToStationData(data, regionid, data.trailid);
        setData(dataWithLocalProgress);
        //setLockedContents(newcontents?.map(item => item.type === "quiz" || item.type === "game"));
        setLockedContents(JSON.parse(dataWithLocalProgress?.newcontents || "[]")?.map(item => item.locked == true));
        setLoading(false);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      triggerRecovery();
    }
  };

  





  return (
    loading ? <div className='stationloadingscreen'>
      {needsManualReload &&
        <button className="loadingreloadbutton button-secondary button-secondary-light stationloadingreloadbutton" type="button" onClick={reloadNow}>
          {translate("reload", localStorage.getItem("language") || "en")}
        </button>
      }
    </div> : (
      <div className={`page-station page-station-${stationid} page-station-trailid-${data.trailid}`}>
        <div className='stationloadingscreen stationloadingscreen-fadeout'></div>
        {newcontents.map((content, idx) => {
          let contentdata = content?.content;
          return (
            <div key={idx} className={`content-wrapper content-wrapper-${stationid}-${idx} ${idx != index ? (idx > index ? "content-wrapper-before" : "content-wrapper-after") : ""}`}>
              {content.type === 'video' && <ContentVideo content={contentdata} active={idx === index} baseurl={data.baseurl} language={data.language} onEnd={indexnext} />}
              {content.type === 'audio' && <ContentAudio content={contentdata} active={idx === index} baseurl={data.baseurl} onEnd={indexnext} />}
              {content.type === 'quiz' && <ContentQuiz content={contentdata} onCompletion={() => handleContentCompletion(idx)} baseurl={data.baseurl} />}
              {content.type === 'image' && <ContentImage content={contentdata} baseurl={data.baseurl} />}
              {content.type === 'camera' && <ContentCamera content={contentdata} active={idx === index} baseurl={data.baseurl} language={data.language} />}
              {content.type === 'external' && <ContentExternal content={contentdata} active={idx === index} baseurl={data.baseurl} />}
              {content.type === 'game' && <ContentGame content={contentdata} onCompletion={() => handleContentCompletion(idx)} onNext={indexnext} active={idx === index} baseurl={data.baseurl} language={data.language} showButtons={x => setShowButtons(x)} />}
              {content.type === 'scratch' && <ContentScratch content={contentdata} active={idx === index} baseurl={data.baseurl} showButtons={x => setShowButtons(x)} />}
              {content.type === 'code' && <ContentCode content={contentdata} active={idx === index} baseurl={data.baseurl} language={data.language} onCompletion={() => handleContentCompletion(idx)} />}
              {content.type === 'colorfilter' && <ContentColorFilter content={contentdata} active={idx === index} baseurl={data.baseurl} language={data.language} />}
              {content.type === 'inspector' && <ContentInspector content={contentdata} active={idx === index} baseurl={data.baseurl} showButtons={x => setShowButtons(x)} />}
              {content.type === 'magnifier' && <ContentMagnifier content={contentdata} active={idx === index} baseurl={data.baseurl} showButtons={x => setShowButtons(x)} />}
              {/* Add more conditions for other content types if needed */}
            </div>
          )
        })}

        <div key={'successitem'} className={`content-wrapper ${newcontents.length != index ? (newcontents.length > index ? "content-wrapper-before" : "content-wrapper-after") : null}`}>
          <StationSuccess title={data.title} baseurl={data.baseurl} contenturl={data?.contenturl} trailid={data.trailid} startAgain={() => setIndex(0)} active={newcontents.length === index} numcontents={newcontents.length} language={data.language} entrytime={entryTime || 0} stations={data?.stations} />
        </div>

        {/*contents[index].type === 'video' && <ContentVideo key={index} content={contents[index].content} />
      contents[index].type === 'quiz' && <ContentQuiz key={index} content={contents[index].content} />*/}

        <div className={`contentarrowcontainer ${((newcontents.length <= index) || !showButtons) && 'contentarrowcontainerhidden'}`}>
          <div className='clickable stationbtn stationprevbtn' style={{ opacity: index > 0 ? 1 : 0 }} onClick={indexprev}><img src={arrowimg} /></div>
          <div className='clickable stationbtn stationnextbtn' onClick={indexnext}>{stationNextButtonText}{lockedContents[index] ? <img src={lockimg} /> : <img className='arrowmove' src={arrowimg} />}</div>
        </div>

        {hasHints && (
          <div className='hintbutton clickable' onClick={() => setHintsOpen(true)}>
            <img src={hinticon} />
            <span>{translate("hints", data.language)}</span>
          </div>
        )}

        <ModalHints
  open={hintsOpen}
  onClose={() => setHintsOpen(false)}
  hints={currentHints}
  lang={data.language}
/>

        <style>{"body{overflow:hidden;}"}</style>
      </div>
    )
  );
}

export default Station;
